import { Skeleton, cn } from "ui";

type SkeletonBadgeProps = {
  className?: string;
};

export const SkeletonBadge = ({ className }: SkeletonBadgeProps) => (
  <Skeleton className={cn("h-6 w-20 rounded-full", className)} />
);
